import { NgModule } from '@angular/core';
import { LegendLayerComponent } from './legend-layer.component';

@NgModule({
  declarations: [LegendLayerComponent],
  exports: [LegendLayerComponent],
})
export class LegendLayerModule {}
